import React from 'react';
import { makeClassName } from '@siteless/util';

const InfoIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    className={makeClassName('InfoIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="none"
    {...rest}
  >
    <circle cx="12" cy="12" r="10" fill="none" />
    <line x1="12" y1="16" x2="12" y2="12" fill="none" />
    <line x1="12" y1="8" x2="12.01" y2="8" fill="none" />
  </svg>
);

export default InfoIcon;
